<script lang="ts">
	import Button from '$lib/components/Button/Button.svelte';
	import { _ } from 'svelte-i18n';

	export let isAUXModalRendered: boolean;
</script>

<div class="accountUnlocked">
	<div class="title">{$_('common.email.account_unlocked.title')}</div>

	<div class="heading">
		{$_('common.email.account_unlocked.message')}
	</div>

	<Button on:click={() => (isAUXModalRendered = false)}>{$_('common.ok')}</Button>
</div>

<style>
	.accountUnlocked {
		display: flex;
		box-sizing: content-box;
		flex-direction: column;
		align-items: center;
		block-size: 30vh;
		max-block-size: calc(100vh - 60px);
		inline-size: 300px;
		padding: 50px;
	}

	.title {
		font-size: var(--fontSizeLarge);
	}

	.heading {
		margin-block: var(--gutterLarge);
		margin-inline: 0;
		color: var(--BLACK);
		font-size: var(--fontSizeNormal);
		font-weight: 500;
		text-align: center;
	}

	:global(.accountUnlocked button:first-of-type) {
		inline-size: 100%;
		margin-block: var(--gutterMedium);
		margin-inline: 0;
	}

	@media screen and (max-width: 575px) {
		.accountUnlocked {
			padding: 0;
			padding-block-start: 50px;
		}
	}
</style>
